import { VueModule } from '@Foundation/utilities';
import HomePageTransparencySlider from './code/Scripts/components/home-page-transparency-slider.vue'

export default VueModule({
  components: {
    HomePageTransparencySlider
  }
});
